<template>
	<div class="sample-data-cta flex-centerize flex-column text-center">
		<div class="title-cont">Click below to send sample data to the subflow's trigger.</div>
		<div class="mt-1 event-description">The subflow will not perform any actions.</div>
		<a href="#" class="light-hover-effect mt-4 mb-4" @click="$emit('cancelSendTestDataToSubflow')">Cancel</a>
		<PrimaryButton large :disabled="isSendingSampleData" @click="$emit('sendTestDataToSubflow')">
			{{ isSendingSampleData ? 'Sending...' : 'Send sample data to subflow' }}
		</PrimaryButton>
	</div>
</template>

<script>
export default {
	name: 'SampleDataCTA',
	props: {
		isSendingSampleData: { type: Boolean },
	},
};
</script>

<style scoped lang="scss">
.sample-data-cta {
	position: relative;
}
</style>
